import axios from 'axios';

export default {
    async list({ page, withoutCustomers }) {
        if (!page)
            page = 1;

        let response = await axios.get('/api/textMessages', { params: { page, withoutCustomers } });
        return response.data;
    },
    async getForCustomer(customer) {
        let response = await axios.get(`/api/customers/${customer.id}/textMessages`);
        return response.data;
    },
    async getForPhoneNumber(phoneNumber) {
        let response = await axios.get(`/api/textMessages/${phoneNumber}`);
        return response.data;
    },
    async sendToCustomer(customer, textMessage) {
        let response = await axios.post(`/api/customers/${customer.id}/textMessages`, textMessage);
        return response.data;
    },
    async sendToPhoneNumber(phoneNumber, textMessage) {
        let response = await axios.post(`/api/textMessages/${phoneNumber}`, textMessage);
        return response.data;
    },
};
